module.exports = __webpack_public_path__ + "static/media/connector-logo_google-cloud-composer.97245ed6.svg";